import React from 'react';
import { TableCell, TableRow } from 'ui-library/table';
import { InputProps } from '@material-ui/core';
import { Input } from '@material-ui/core';

export const InputFullWidth = (props: InputProps) => <Input style={{ width: '100%' }} {...props} />;

export const TableRowInput = ({ colSpan = 1, ...props }: InputProps & { colSpan?: number }) => (
	<TableRow>
		<TableCell colSpan={colSpan}>
			<InputFullWidth {...props} />
		</TableCell>
	</TableRow>
);
